import React, { useContext, useEffect } from "react";
import "./Home.scss";
import Cad from "@pages/cad/Cad";
import UtilServices from "@services/UtilServices";
import GlobalContext from "@context/GlobalContext";
import useLoading from "@hooks/useLoading";
import EndPointServices from "@services/ApiServices";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [state, dispatch] = useContext(GlobalContext);
  const [setLoading] = useLoading();
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/CAD");
  }, []);

  return <div className="home row"></div>;
};

export default Home;
